<template>
<div>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h2 class="card-title d-flex">TEST AUFRUFE
        </h2>
        <div class="d-flex">
          <vs-input v-model="hubText"></vs-input><vs-button class="ml-2" size="small" @click="testHUB()">HUB Hello</vs-button>
        </div>
        <div>
          <vs-button class="ml-2" size="small" @click="testHubUser()">HUB USER!!!</vs-button>
          <vs-button class="ml-2" size="small" @click="helloWorld()">Hello World!</vs-button>
        </div>
      </vs-card>
      <vs-card>
        <h2 class="card-title d-flex">Infoworx Import
        </h2>
        {{this.limit}}
        <div class="d-flex">
          <vs-input v-model="partnernr" label="Partner-Nummer" placeholder="2008E004"></vs-input>
          <vs-input v-model="numbergroup" label="Nummernkreis Bez"></vs-input>
          <vs-input-number v-model="take" label="Anzahl Kunden (0 = alle)" />
          <vs-input-number v-model="skip" label="Überspringen" />
          <vs-button class="ml-2" size="small" @click="importInfoworx()">Run</vs-button>
        </div>

      </vs-card>      
    </vs-col>
  </vs-row>

</div>
</template>

<script>

import helperMethods from '../helper/staticFuncHelper';
import enumHelper from '../helper/enumHelper';
import codeHelper from '../helper/staticCodeHelper';

export default {
  name: "TestCalls",
  components: {
  },
    data: function (){
      return {
      hubText:"",
      partnernr:"2008E004",
      numbergroup:"Kunden Österreich",
      take:0,
      skip:0
      };
  },
  mounted () {

    },
  computed: 
  { 
    
  },
  watch: {
     
      
    },
  methods: {    
      ...helperMethods,
      ...enumHelper,
      ...codeHelper,
     
      testHUB()
      {
        this.$store.dispatch('testcall/testHub',{ text:this.hubText})
        .then(response => {
          if(response.success == true)
          {
            this.$store.dispatch('alertqueue/addSuccess', {'titel':this.$t('COM.SUCCESS.TITEL'),'text':'HUB TEST CALL: '+response.text});  
          }
          else
          {
            this.$store.dispatch('alertqueue/addWarning', {'titel':this.$t('COM.WARNING.TITEL'),'text':'FAIL'}); 
          }
          this.hubText = "";
        }, 
        error =>{
            this.hubText = "";
            this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':'total Fail: '+error});  
        });
      },
      testHubUser()
      {
        this.$store.dispatch('testcall/testHubUser')
        .then(response => {
          if(response.success == true)
          {
            this.$store.dispatch('alertqueue/addSuccess', {'titel':this.$t('COM.SUCCESS.TITEL'),'text':'HUB TEST CALL: '+response.text});  
          }
          else
          {
            this.$store.dispatch('alertqueue/addWarning', {'titel':this.$t('COM.WARNING.TITEL'),'text':'FAIL'}); 
          }
          this.hubText = "";
        }, 
        error =>{
            this.hubText = "";
            this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':'total Fail: '+error});  
        });
      },
      helloWorld(){
        this.$store.dispatch('testcall/helloWorld')
        .then(response => {

            this.$store.dispatch('alertqueue/addSuccess', {'titel':this.$t('COM.SUCCESS.TITEL'),'text':'HUB TEST CALL: '+response});  
        }, 
        error =>{
            this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':'total Fail: '+error});  
        });
      },
      importInfoworx()
      {
        var data = {partnernr: this.partnernr, numbergroup: this.numbergroup, take: Number(this.take), skip: Number(this.skip)};
        this.$store.dispatch('debitor/importDebitorsFromCsv',data)
        .then(response => {
          if(response.success == true)
          {
            this.$store.dispatch('alertqueue/addSuccess', {'titel':this.$t('COM.SUCCESS.TITEL'),'text':'importDebitorsFromCsv: '+response.text});  
          }
          else
          {
            this.$store.dispatch('alertqueue/addWarning', {'titel':this.$t('COM.WARNING.TITEL'),'text':'FAIL'}); 
          }
          this.hubText = "";
        }, 
        error =>{
            this.hubText = "";
            this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':'total Fail: '+error});  
        });
      }
  }
};

</script>